import { Col, Form, Row } from "react-bootstrap";
import FileInput from "../FileInput";
import ImageInput from "../theme-management/ImageInput";
import Switch from "react-switch";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { API } from "../../App";

const BasicInformation = ({
  formData,
  setFormData,
  onInputChange,
  handleFileChange,
  fileNames,
  files,
  validate,
}) => {
  const [keyboardCategories, setKeyboardCategories] = useState([]);

  const fetchKeyboardCategories = async () => {
    try {
      const token = Cookies.get("jwt");
      const res = await API.post(
        "/keyboardCategories",
        {},
        {
          headers: { authorization: `Bearer ${token}` },
        }
      );
      setKeyboardCategories(res.data.data || []);
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  useEffect(() => {
    fetchKeyboardCategories();
  }, []);
  return (
    <Row>
      <Col lg={3} sm={12}>
        <Form.Group>
          <Form.Label htmlFor="rank">New Index</Form.Label>
          <Form.Control
            type="number"
            name="rank"
            id="rank"
            value={formData.rank}
            onChange={onInputChange}
            className="my-2"
            required
          />
          <Form.Control.Feedback type="invalid">
            Enter Index
          </Form.Control.Feedback>
        </Form.Group>
      </Col>
      <Col lg={3} sm={12}>
        <Form.Group>
          <Form.Label htmlFor="name">Name</Form.Label>
          <Form.Control
            type="text"
            name="name"
            id="name"
            value={formData.name}
            onChange={onInputChange}
            className="my-2"
            required
            autoComplete="off"
          />
          <Form.Control.Feedback type="invalid">
            Enter Name
          </Form.Control.Feedback>
        </Form.Group>
      </Col>
      <Col lg={3} sm={12}>
        <FileInput
          label="Thumb Image"
          name="thumb_image"
          onChange={handleFileChange}
          required={true}
          fileName={fileNames.thumb_image}
          accept="image/*"
          isInvalid={validate && !files.thumb_image}
          feedback="Upload a thumb image."
        />
      </Col>
      <Col lg={3} sm={12}>
        <FileInput
          label="Thumb Image (iPhone)"
          name="thumb_image_iphone"
          onChange={handleFileChange}
          required={false}
          fileName={fileNames.thumb_image_iphone}
          accept="image/*"
        />
      </Col>
      <Col lg={3} sm={12}>
        <FileInput
          label="Thumb Image (iPad)"
          name="thumb_image_ipad"
          onChange={handleFileChange}
          required={false}
          fileName={fileNames.thumb_image_ipad}
          accept="image/*"
        />
      </Col>
      <Col lg={3} sm={12}>
        <ImageInput
          label="Full Image (iPhone)"
          accept="image/*"
          existingUrl={typeof files?.full_image_iphone === "string" ? files.full_image_iphone : null}
          onChange={(file) =>
            handleFileChange({ target: { name: "full_image_iphone", files: file ? [file] : [] } })
          }
        />
      </Col>
      <Col lg={3} sm={12}>
        <ImageInput
          label="Full Image (iPad)"
          accept="image/*"
          existingUrl={typeof files?.full_image_ipad === "string" ? files.full_image_ipad : null}
          onChange={(file) =>
            handleFileChange({ target: { name: "full_image_ipad", files: file ? [file] : [] } })
          }
        />
      </Col>
      <Col lg={3} sm={12}>
        <FileInput
          label="JSON File"
          name="json_name"
          onChange={handleFileChange}
          required={false}
          fileName={fileNames.json_name}
          accept="application/json"
          // isInvalid={validate && !files.json_name}
          // feedback="Please upload a valid JSON file."
        />
      </Col>
      <Col lg={3} sm="12" className="mb-2">
        <Form.Label className="d-block mb-2">Is Status</Form.Label>
        <Switch
          onChange={(checked) => setFormData({ ...formData, status: checked })}
          checked={formData.status}
          offColor="#C8C8C8"
          onColor="#0093ed"
          height={30}
          width={70}
          className="react-switch"
          uncheckedIcon={<div className="react-switch-off">OFF</div>}
          checkedIcon={<div className="react-switch-on">ON</div>}
          required
        />
      </Col>
      <Col lg={3} sm="12" className="mb-2">
        <Form.Label className="d-block mb-2">Is Premium</Form.Label>
        <Switch
          onChange={(checked) =>
            setFormData({ ...formData, is_premium: checked })
          }
          checked={formData.is_premium}
          offColor="#C8C8C8"
          onColor="#0093ed"
          height={30}
          width={70}
          className="react-switch"
          uncheckedIcon={<div className="react-switch-off">NO</div>}
          checkedIcon={<div className="react-switch-on">YES</div>}
        />
      </Col>
      {/* <Col lg={3} sm="12" className="mb-2">
        <Form.Label className="d-block mb-2">Is Border</Form.Label>
        <Switch
          onChange={(checked) =>
            setFormData({ ...formData, is_premium: checked })
          }
          checked={formData.is_Border}
          offColor="#C8C8C8"
          onColor="#0093ed"
          height={30}
          width={70}
          className="react-switch"
          uncheckedIcon={<div className="react-switch-off">NO</div>}
          checkedIcon={<div className="react-switch-on">YES</div>}
        />
      </Col> */}
      <Col lg={3} sm="12" className="mb-2">
        <Form.Label className="d-block mb-2">Is Watch Video</Form.Label>
        <Switch
          onChange={(checked) =>
            setFormData({ ...formData, is_premium: checked })
          }
          checked={formData.is_Watch_Video}
          offColor="#C8C8C8"
          onColor="#0093ed"
          height={30}
          width={70}
          className="react-switch"
          uncheckedIcon={<div className="react-switch-off">NO</div>}
          checkedIcon={<div className="react-switch-on">YES</div>}
        />
      </Col>
      <Col lg={3} sm={12}>
        <Form.Group>
          <Form.Label>Loop Mode</Form.Label>
          <Form.Select
            name="loop_Mode"
            value={formData.loop_Mode}
            onChange={onInputChange}
            className="my-2"
            required={false}
          >
            <option value="">Select Loop Mode</option>
            <option value={1}>For Loop</option>
            <option value={0}>Auto Reverse</option>
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            Select Loop Mode
          </Form.Control.Feedback>
        </Form.Group>
      </Col>
      <Col lg={3} sm={12}>
        <Form.Group>
          <Form.Label>Keyboard Category</Form.Label>
          <Form.Select
            value={formData.keyboardCategory}
            name="keyboardCategory"
            onChange={onInputChange}
            className="my-2"
            required
          >
            <option value="">Select Category</option>
            {keyboardCategories.map((category) => (
              <option key={category._id} value={category._id}>
                {category.name}
              </option>
            ))}
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            Select Keyboard Category
          </Form.Control.Feedback>
        </Form.Group>
      </Col>
      <Col lg={3} sm={12}>
        <FileInput
          label="Keyboard Watch Ad Image"
          name="keyboard_full_image_watch_ad"
          onChange={handleFileChange}
          required={true}
          fileName={fileNames.keyboard_full_image_watch_ad}
          accept="image/*"
        />
      </Col>
      <Col lg={3} sm={12}>
        <FileInput
          label="Keyboard Background Image"
          name="keyboard_bg_image"
          onChange={handleFileChange}
          required={false}
          fileName={fileNames.keyboard_bg_image}
          accept="image/*"
        />
      </Col>
    </Row>
  );
};

export default BasicInformation;
